import { call, put, takeEvery } from 'redux-saga/effects';
import { getCapDerivatives } from '../../../requests/cap_requests/get_cap_derivatives_request';
import { getLeadsCapDerivativesRequestSuccess, getLeadsCapDerivativesRequestFailure } from '../../actions/cap_actions/get_cap_derivatives.actions';
import { GET_LEADS_CAP_DERIVATIVES_REQUEST } from '../../constants/cap.constants';
import { message_error } from '../../../../../../components/Message';

function* getCapDerivativesRequest({ variant_id }) {
    const { result, options, error } = yield call(getCapDerivatives, variant_id);
    if (result) {
        yield put(getLeadsCapDerivativesRequestSuccess(options));
    } else {
        yield put(getLeadsCapDerivativesRequestFailure(error));
        message_error(error);
    }
}

export default function* getCapDerivativesSaga() {
    yield takeEvery(GET_LEADS_CAP_DERIVATIVES_REQUEST, getCapDerivativesRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/cap.sagas/get_cap_derivatives.saga.js